<template>
  <div class="dh-psy-vhxl">
    <Esi :src="src" />
  </div>
</template>

<script>
import Esi from '../../Utilities/Esi.vue'

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    src() {
      return `serum/render?id=${this.id}`
    }
  },
  components: {
    Esi
  }
}
</script>

<style scoped lang="postcss">
</style>
